export default (siteId, extraFields) => {
  const template = `
<script type="text/javascript" src="//path.twyne.io/scripts/embed.js"></script>
<script type="text/javascript" id="userenroll-embed" class="userenroll-embed">
  (function(global) {
    function userenroll_load(){
      var data = {};

      data.siteId     = '${siteId || ''}';
      data.firstName  = 'test';
      data.lastName   = 'test';
      data.email      = 'test@example.com';
      data.address1   = 'address1';
      data.address2   = '';
      data.city       = 'city';
      data.state      = 'state';
      data.zip        = '12345';
      data.country    = 'usa';
      data.phone      = '2345552344';
      data.dobMonth   = '01'; // mm
      data.dobDay     = '01'; // dd
      data.dobYear    = '2012'; // yyyy
      data.gender     = 'M'; // 'M' or 'F'
      data.pid        = '1';
      data.sid1       = '';
      data.sid2       = '';
      data.sid3       = '';

      // return URL for when a user completes the path
      data.rurl       = 'http://example.com';

      //data.optout	 = string('true' | 'false'); // Consumer CCPA optout. Please provide.

      //data.registration_leadid = '000000XX-X0XX-000X-0X0X-X0000XXX0XXX';
      //data.registration_trustedform = 'https://cert.trustedform.com/x0xx0xx000xxxx000xx00x0xx0000xx0x00000x0';

      /*
      * Specify Extra Fields
      *
      * (optional)
      */
${extraFields || ''}


      /*
      * Specify whether the user is a duplicate.
      * Note: This overrides the duplicate check done by User Enroll
      *
      * (optional)
      */
      //data.duplicateUser  = ('true' | 'false');

      /*
      * ID of default path to display to user
      * Note: This only overrides the default path. If a user profile rule
      *       is matched, that path will be displayed instead. If you want
      *       to override all path logic, use the pathOverride parameter
      *       instead.
      *
      * (optional)
      */
      //data.defaultPathOverride   = '123';

      /*
      * ID of path to display to user (optional)
      * WARNING: This bypasses all path logic
      *
      * (optional)
      */
      //data.pathOverride   = '123';

      /*
      * Token for use with API callback
      *
      * (optional)
      */
      //data.callbackToken   = '123';

      global.userEnroll.initEmbed(data);
    }

    userenroll_load();
  })(this);
</script>  
  `;

  return template.trim();
}